import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styled, { css } from 'styled-components';
import Icon from './Search/common/atoms/Icon';

const HOVER_ICON_OPTIONS = {
  TRANSITIONS: {
    DEFAULT: 'default',
    SHARP: 'sharp',
  },
};

const StyledRoot = styled.div`
  display: flex;
  position: relative;
  max-width: 100%;
  align-items: center;
  a,
  button {
    cursor: pointer;
  }
  &:hover .HoverIcon__hoverIcon {
    left: 0;
    color: ${props => props.theme.primary.normal};
    opacity: 1;
    text-indent: -7px;
  }

  /** TRANSITION */
  ${props => {
    switch (props.transition) {
      case HOVER_ICON_OPTIONS.TRANSITIONS.SHARP:
        return css`
          transition: ${props.theme.transition.create(['all'], {
            duration: props.theme.transition.duration.shortest,
            timingFunction: props.theme.transition.timingFunction.sharp,
          })};
        `;
      case HOVER_ICON_OPTIONS.TRANSITIONS.DEFAULT:
      default:
        return css`
          transition: all 0.3s ease;
        `;
    }
  }}
`;

const StyledIcon = styled(Icon)`
  top: -12px;
  left: -17px;
  color: transparent;
  height: 16px;
  position: relative;
  font-size: 48px;
  opacity: 0;

  @media (max-width: 767px) {
    display: none;
  }

  /** TRANSITION */
  ${props => {
    switch (props.transition) {
      case HOVER_ICON_OPTIONS.TRANSITIONS.FAST:
        return css`
          transition: ${props.theme.transition.create(['all'], {
            duration: props.theme.transition.duration.shortest,
            timingFunction: props.theme.transition.timingFunction.sharp,
          })};
        `;
      case HOVER_ICON_OPTIONS.TRANSITIONS.DEFAULT:
      default:
        return css`
          transition: all 0.3s ease;
        `;
    }
  }}
`;

const HoverIcon = ({ children, className, icon, transition, ...props }) => {
  const iconName = icon ? icon.replace(/(^icon-)/gi, '') : 'generalarrowesmall';
  return (
    <StyledRoot
      className={classnames('HoverIcon__root', className)}
      transition={transition}
      {...props}
    >
      {children}
      <StyledIcon
        icon={iconName}
        className="ls-icon HoverIcon__hoverIcon"
        transition={transition}
      />
    </StyledRoot>
  );
};

HoverIcon.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  transition: PropTypes.oneOf(Object.values(HOVER_ICON_OPTIONS.TRANSITIONS)),
};

HoverIcon.defaultProps = {
  children: undefined,
  className: undefined,
  transition: HOVER_ICON_OPTIONS.TRANSITIONS.DEFAULT,
};

export default HoverIcon;
export { HOVER_ICON_OPTIONS };
